import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../RootState';
import axios from "axios";
import {settings} from "@/plugins/settings";
import {IErrors} from "@/model/IErrors";
import responseHandler from "@/plugins/errorHandling";
import {IShortChannel} from "@/model/shortInterfaces";
import {IChannelSetting} from "@/model/Channel/IChannelSetting";

interface ChannelState {
  // channel?: IChannel;
  channels: IShortChannel[];
  channelSettings: IChannelSetting[];
  errors: IErrors;
}

const state: ChannelState = {
  // channel: undefined,
  channels: [],
  channelSettings: [],
  errors: {},
};

const getters: GetterTree<ChannelState, RootState> = {
  // channel: (state) => state.channel,
  channels: (state) => state.channels,
  channelSettings: (state) => state.channelSettings,
  errors: (state) => state.errors,
};

const actions: ActionTree<ChannelState, RootState> = {
  fetchChannels: ({commit}): any => responseHandler.handle(
    () => axios.get(settings.endpoint + 'channels'),
    commit,
    'channelsLoaded'
  ),
  fetchChannelSettings: ({commit}): any => responseHandler.debounce<IChannelSetting[]>(
    state.channelSettings,
    300,
    () => axios.get(settings.endpoint + 'channels/settings'),
    commit,
    'channelSettingsLoaded'
  ),
  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  },
  cleanError: ({commit}, index: any): any => {
    commit('cleanError', index);
  },
};

const mutations: MutationTree<ChannelState> = {
  // channelLoaded(state, payload) {
  //   state.channel = payload;
  // },
  channelsLoaded(state, payload) {
    state.channels = payload;
  },
  channelSettingsLoaded(state, payload) {
    state.channelSettings = payload;
  },
  errors(state, payload: IErrors) {
    state.errors = payload;
  },
  cleanError(state, index: string) {
    delete(state.errors[index]);
  },
};

const namespaced: boolean = true;

export const channelModule: Module<ChannelState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
